import Forms from "./_app/cuchillo/forms/FormValidator";

export default class Main {
  static init() {

    window.setupForms = this.setupForms ? this.setupForms : () => { };
    window.disposeForms = this.disposeForms ? this.disposeForms : () => { };
  }

  static disposeForms() {
  }

  static setupForms() {
    Forms.init();
  }
}

if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
  Main.init();
} else {
  document.addEventListener('DOMContentLoaded', Main.init);
}
